import {UserFlowList, UserFlowStep} from './BaseUserFlow';
import {SaveUserFlow} from './SaveUserFlow';
import {UserFlowType} from './UserFlowFacade';

export class ShareUserFlow extends SaveUserFlow {
  protected type = UserFlowType.Share;
  // protected canCancel = false;

  public getCurrentStep(): string {
    return this.steps[this.getStep()] || `${this.type}.${UserFlowStep.None}`;
  }

  /**
   * @inheritdoc
   */
  public configure(): UserFlowList {
    const newSteps = super.configure();

    newSteps.push(`${UserFlowType.Share}.${UserFlowStep.ShareInititialise}`);
    newSteps.push(`${UserFlowType.Share}.${UserFlowStep.Share}`);

    // Steps may have changed if the user logged in so we need to adjust the current step.
    // const currentStepCount = this.steps.length;
    // const stepCount = newSteps.length;

    // if (currentStepCount > 0 && stepCount < currentStepCount) {
    //   const adjustedStep = currentStepCount - stepCount;
    //   this.setStep(Math.max(0, this.getStep() - adjustedStep));
    // }

    return newSteps;
  }
}
